export function getProductHref(product: any, preferredParent?: string) {
  if (!product || !product.slug) return '';
  // If caller provided a parent slug (from category/collection page), use it
  if (preferredParent) {
    return `/${preferredParent}/${product.slug}`;
  }

  // Try common fields that may contain category/collection slugs
  const categorySlug =
    product.categorySlug ||
    product.category?.slug ||
    (product.categories && product.categories[0] && product.categories[0].slug) ||
    (product.categorySlugs && product.categorySlugs[0]);
  if (categorySlug) return `/${categorySlug}/${product.slug}`;

  const collectionSlug =
    product.collectionSlug ||
    product.collection?.slug ||
    (product.collections && product.collections[0] && product.collections[0].slug) ||
    (product.collectionSlugs && product.collectionSlugs[0]);
  if (collectionSlug) return `/${collectionSlug}/${product.slug}`;

  // Fallback to product slug at root
  return `/${product.slug}`;
}

export default getProductHref;
